import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import MobileProductFilter from './MobileProductFilter'
import { ReactComponent as User } from "../../images/mobile/filters/user.svg"
import { ReactComponent as Point } from "../../images/mobile/filters/point.svg"
import { ReactComponent as Randomize } from "../../images/mobile/filters/randomize.svg"
import { ReactComponent as Favs } from "../../images/mobile/filters/favs.svg"
import { ReactComponent as Loop } from "../../images/mobile/filters/loop.svg"
import { ReactComponent as Oneshot } from "../../images/mobile/filters/oneshot.svg"
import { ReactComponent as Wave } from "../../images/mobile/filters/wave.svg"
import CancelCross from '#images/cancel-cross.svg'

@inject('filtersStore', 'authStore')
@observer
class MobileFilterResults extends Component {
  constructor(props) {
    super(props)
    var initialState = {}
    this.filterNames.forEach((filter) =>
      initialState[filter] = this.props.filtersStore[filter]
    )
    this.state = initialState
  }

  get filterNames() {
     return ['user', 'shop', 'favs', 'loop', 'oneshot', 'wave', 'randomize']
  }

  toggleFilter = (filter) => {
    if (filter == 'loop' && !this.state.loop && this.state.oneshot) {
      this.setState({oneshot: false})
    } else if (filter == 'oneshot' && this.state.loop && !this.state.oneshot) {
      this.setState({loop: false})
    } else if (filter == 'user' && this.state.user && !this.state.shop) {
      this.setState({shop: true})
    } else if (filter == 'shop' && !this.state.user && this.state.shop) {
      this.setState({user: true})
    }
    this.setState({[filter]: !this.state[filter]})
  }

  submitFilters = () => {
    const { filtersStore } = this.props
    this.filterNames.forEach((filter) => {
      if (this.state[filter] != filtersStore[filter]) {
        // construct toggling method name, e.g. 'toggleOneshot'
        this.props.filtersStore['toggle' + filter.charAt(0).toUpperCase() + filter.substring(1)]()
      }
    })
    this.props.goAction()
  }

  render() {
    const { filtersStore, library, disableFavs, disableRandomize } = this.props;
    const state = this.state
    const toggleFilter = this.toggleFilter

    return (
      <div
        className='fixed md:hidden inset-x-0 inset-y-0 bg-gray-16 z-50 px-5 py-9 overflow-y-scroll'
      >
        <div
          className='flex mb-9'
        >
          <span className='font-bold text-2xl text-white'>Filter Results</span>
          <button type='button' className='ml-auto'>
            <img
              src={CancelCross}
              onClick={this.props.closeAction}
              className='brightness-125'
            />
          </button>
        </div>

        <div
          className='flex flex-col'
        >
          {
            this.props.authStore.isLoggedIn &&
              <>
                <MobileProductFilter
                  active={state.user}
                  toggle={() => toggleFilter('user')}
                  img={User}
                >
                  Your Sounds
                </MobileProductFilter>
                <MobileProductFilter
                  active={state.shop}
                  toggle={() => toggleFilter('shop')}
                  img={Point}
                >
                  Store
                </MobileProductFilter>
                {
                  !disableFavs && (
                    <MobileProductFilter
                      active={state.favs}
                      toggle={() => toggleFilter('favs')}
                      img={Favs}
                    >
                       Favourites
                    </MobileProductFilter>
                  )
                }
              </>
          }

          <MobileProductFilter
            active={state.loop}
            toggle={() => toggleFilter('loop')}
            img={Loop}
          >
            Loops
          </MobileProductFilter>
          <MobileProductFilter
            active={state.oneshot}
            toggle={() => toggleFilter('oneshot')}
            img={Oneshot}
          >
            One-Shot
          </MobileProductFilter>
          <MobileProductFilter
            active={state.wave}
            toggle={() => toggleFilter('wave')}
            img={Wave}
          >
            WAV
          </MobileProductFilter>

          {
            !library &&
              <>
                {
                  !disableRandomize && (
                    <MobileProductFilter
                      active={state.randomize}
                      toggle={() => toggleFilter('randomize')}
                      img={Randomize}
                    >
                       Randomize
                    </MobileProductFilter>
                  )
                }
              </>
          }

          <button
            type='button'
            className='bg-orange-1 mt-7 text-2xl font-medium text-gray-16 text-center py-1 rounded-[40px]'
            onClick={this.submitFilters}
          >
            GO
          </button>
        </div>
      </div>
    )
  }
}

export default MobileFilterResults
